import { BaseFeature, FeatureType } from '@core/shared/feature';
export class TaskSchedulerBaseFeature extends BaseFeature {
  static {
    this.featureInfo = {
      context: {"package":"@common/task-scheduler/feature","featureId":"common-task-scheduler"},
      bundledItemModels: ["TaskSchedulerLogItem", "ScheduledTaskItem"],
      // list is auto-generated by generate-model-ids
      abilityActions: false,
      dependencies: [],
      plugins: [
      // {forPlatform:'frontend', type:FeatureType.Permanent, pluginClassName:'TaskSchedulerFrontendFeature'},
      // {forPlatform:'frontend-management', type:FeatureType.Dynamic, pluginClassName:'TaskSchedulerFrontendManagementFeature', simpleAbilityCheck:'MANAGER' },
      {
        forPlatform: 'admin',
        type: FeatureType.Permanent,
        pluginClassName: 'TaskSchedulerFrontendAdminFeature'
      },
      // {forPlatform:'backend', type:FeatureType.Permanent, pluginClassName:'TaskSchedulerBackendFeature'},
      {
        forPlatform: 'backend-admin',
        type: FeatureType.Permanent,
        pluginClassName: 'TaskSchedulerBackendAdminFeature'
      }]
    };
  }
  getSharedDefinition() {
    return {
      routerLinkResolvers: {
        frontend: {}
      }
    };
  }
}